/*---------------------------------------------------------------------*/

import { getToken, getTokenOverdrive } from "../services/tokenizer";

/* formatUrlName method returns a suitable string to be used 
    in a browser path truncated to 7 words.
    Eg.1:
        input: "LA historia  navaja - dd?/ ´sDd %df"
        output: "la-historia-navaja-dd-sdd-df"
*/
export const formatUrlName = (str) => {
    const words = str.normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^\w\s]/gi, "")
        .replace(/\s+/g, "-")
        .toLowerCase()
        .split("-");

    return words.slice(0, 7).join("-");
};

export const switchBookType = (name) => {
    switch (name) {
        case "physical":
            return "libros-fisicos";
        case "digital":
            return "libros-digitales";
        default:
            return "libros";
    }
}

export const validateOverDriveTokenExpiration: () => boolean = (): boolean => {
    const currentDate: Date = new Date();
    const expirationOverdriveTokenString = localStorage.getItem('expirationOverdriveToken');
    const overdriveToken = localStorage.getItem('overdriveToken');
    const collectionToken = localStorage.getItem("collectionToken") ?? "";
    const collectionToken2 = localStorage.getItem("collectionTokenBackUp") ?? "";

    if (collectionToken != collectionToken2) {
        localStorage.setItem("collectionTokenBackUp", collectionToken)
        return false;
    }

    if (!overdriveToken) {
        return false;
    }

    if (!expirationOverdriveTokenString) {
        return false;
    }

    const expirationOverdriveToken: Date = new Date(parseInt(expirationOverdriveTokenString, 10));

    return currentDate < expirationOverdriveToken;
}


export const getOverdriveToken = async (payload: { jwt: string }): Promise<void> => {
    try {
        const data = await getTokenOverdrive(payload);

        if (data?.data?.data?.accessToken) {
            const accessToken = data.data.data.accessToken;
            localStorage.setItem('overdriveToken', accessToken);
            localStorage.setItem('expirationOverdriveToken', (Date.now() + 55 * 60 * 1000).toString());
        }
    } catch (error) {
        console.error('Error al obtener el token de Overdrive:', error);
    }
};

export const getJwt = async () => {

    try {
        const req = await getToken(localStorage.getItem("uid"))

        if (req && req.data.status === 200 && req.data.data.accessToken) {
            const accessToken: string = req.data.data.accessToken;

            localStorage.setItem('uidToken', accessToken)
            return accessToken;
        } else {
            console.error('Error al obtener el token de CDC')
        }
    } catch (error) {
        console.error('Error al obtener el token de CDC:', error);
    }
}
